export default {
  COOKIES_ACCEPTED: 'cookies-accepted',
};
